import { defineStore } from 'pinia'
import { ref } from 'vue'
import type { CatalogDefaultStoreType, CatalogPaymentMethodResponseType } from '@nailsupply/review-swagger/catalog'
import type { EmployeesListResponseType } from '@nailsupply/review-swagger/employees'
import type { CategoryResponseType } from '@nailsupply/review-swagger/categories'
import type { StatusOnboardingType } from '@/types/store'
import type { ServiceWithChildren } from '@/types/service'

export const useOnboardingStore = defineStore('onboardingStore', () => {
  const defaultStore = ref<CatalogDefaultStoreType | null>(null)
  const onboardingStatus = ref<StatusOnboardingType | null>(null)
  const paymentMethods = ref<CatalogPaymentMethodResponseType[]>([])
  const selectedPaymentMethodIds = ref<string[]>([])
  const defaultServices = ref<ServiceWithChildren[]>([])
  const defaultServicesLoaded = ref(false)
  const defaultCategories = ref<CategoryResponseType[]>([])
  const defaultCategoriesLoaded = ref(false)
  const defaultEmployees = ref<EmployeesListResponseType>([])
  const defaultEmployeesLoaded = ref(false)

  const setDefaultStore = (data: CatalogDefaultStoreType | null) => {
    defaultStore.value = data
  }

  const setOnboardingStatus = (data: StatusOnboardingType | null) => {
    onboardingStatus.value = data;
  }

  const setPaymentMethods = (data: CatalogPaymentMethodResponseType[]) => {
    paymentMethods.value = Array.isArray(data) ? data : []
  }

  const setSelectedPaymentMethodIds = (ids: string[]) => {
    selectedPaymentMethodIds.value = Array.isArray(ids) ? ids : []
  }

  const togglePaymentMethod = (id: string, checked: boolean) => {
    const current = new Set(selectedPaymentMethodIds.value)
    if (checked) 
current.add(id)
    else current.delete(id)
    selectedPaymentMethodIds.value = Array.from(current)
  }

  const selectAllPaymentMethods = (checked: boolean) => {
    if (!checked) {
      selectedPaymentMethodIds.value = []
      return
    }
    selectedPaymentMethodIds.value = paymentMethods.value.map((m) => String((m as any)._id));
    console.log(selectedPaymentMethodIds.value = paymentMethods.value.map((m) => String((m as any)._id)));
  }

  const setDefaultServices = (data: ServiceWithChildren[] | null) => {
    defaultServices.value = data ?? []
    defaultServicesLoaded.value = true
  }

  const setDefaultCategories = (data: CategoryResponseType[] | null) => {
    defaultCategories.value = data ?? []
    defaultCategoriesLoaded.value = true
  }

  const setDefaultEmployees = (data: EmployeesListResponseType | null) => {
    defaultEmployees.value = data ?? []
    defaultEmployeesLoaded.value = true
  }

  const resetOnboarding = () => {
    defaultStore.value = null
    onboardingStatus.value = null
    paymentMethods.value = []
    selectedPaymentMethodIds.value = []
    defaultServices.value = []
    defaultServicesLoaded.value = false
    defaultCategories.value = []
    defaultCategoriesLoaded.value = false
    defaultEmployees.value = []
    defaultEmployeesLoaded.value = false
  }

  return {
    defaultStore,
    onboardingStatus,
    paymentMethods,
    selectedPaymentMethodIds,
    defaultServices,
    defaultServicesLoaded,
    defaultCategories,
    defaultCategoriesLoaded,
    defaultEmployees,
    defaultEmployeesLoaded,
    setDefaultStore,
    setOnboardingStatus,
    setPaymentMethods,
    setSelectedPaymentMethodIds,
    togglePaymentMethod,
    selectAllPaymentMethods,
    setDefaultServices,
    setDefaultCategories,
    setDefaultEmployees,
    resetOnboarding
  }
})
